import React from 'react';
import moment from 'moment';
import SectionCard from 'components/organisms/section_card';

const ChatSection = ({ data }: any) => {
  if (!data?.length) return null;

  return (
    <SectionCard title="Principais mensagens do chat" icon="description">
      <div className="timeline">
        {data.map((item: any) => (
          <div key={`${item?.data}-${item?.mensagem}`} className="timeline-item">
            <div className="timeline-date">
              {moment(item?.data, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY [às] HH:mm')}
            </div>
            <div className="timeline-content">{item?.mensagem}</div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default ChatSection;
